import React, { FunctionComponent } from 'react'

const Placeholder: FunctionComponent = () => (
  <div>{document.location.pathname} - Placeholder</div>
)

export default Placeholder
